// import React from 'react';
import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import { FIELDS, STEPS } from '../utils/constants';
import { useFormStateContext } from '../utils/hooks';
import {
  InputField,
  InputError,
  InputContainer,
  InputLabel,
  Flex,
  Button,
} from '../utils/styles';

import DatePicker from "react-datepicker";



export const BirthDate = () => {
  const { fields, setStep, updateFields } = useFormStateContext();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { birthdate: fields.birthdate } });

  const goBack = () => {
    setStep(STEPS.MOBILE);
  };

  const onSubmit = (data) => {
    console.log(data);
    updateFields(FIELDS.BIRTHDATE, data.birthdate);
    setStep(STEPS.COUNTRYCODE);
  };

  const onError = (errors, event) => {
    console.log(errors);
    console.log(event);
  };

  const [startDate, setStartDate] = useState(new Date());
  //   const [endDate, setEndDate] = useState(new Date('May 28, 2022'));

  // const [startDate, setStartDate] = useState(null);


  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0 so need to add 1 to make it 1!
  var yyyy = today.getFullYear();

  if (dd < 10) {
    dd = '0' + dd
  }

  if (mm < 10) {
    mm = '0' + mm
  }

  today = yyyy + '-' + mm + '-' + dd;
  var minDate = "1890-05-25"
  var maxDate = "2005-01-18"


  return (

    <div className="base-form">
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <div className='button-back'>
          <Button
            type="button"
            children="Back"
            secondary
            style={{ margin: '0 10px' }}
            onClick={goBack}
          > <i class="fa fa-angle-left" aria-hidden="true"></i></Button>
          <h4>Select birthdate</h4>
        </div>
        <div className="f-container">
          <label className='name'>Birth Date (18+ Only)</label>
          <InputContainer style={{ margin: '10px 0' }} error={errors.birthdate}>
            <Flex alignItems="center" justifyContent="space-between">
              <InputLabel htmlFor="" children="" />
              {errors.birthdate && <InputError children={errors.birthdate.message} />}
            </Flex>



            {/* <input type="date" name="DOB"  min={minDate} max={maxDate} /> */}

            {/* <DatePicker 
            // minDate={moment().subtract(500, "years")}
            // maxDate={moment().subtract(+18, "years")}
              selected={startDate} 
              onChange={date => setStartDate(date)} 
              max="2005-01-18" 
              // max="Jan 01, 2005"
            /> */}
            {/* <DatePicker
              selected={Date.now()
              }
              onChange={handleDateChange}
              showMonthYearPicker
              dateFormat="MM/yyyy"
            /> */}

            <InputField

              id="birthdate"
              type="date"
              className="quesadilla"
              min={minDate} max={maxDate}

              {...register('birthdate', {
                required: 'Birthdate is required',
                pattern: {
                  message: 'Select the Birth-Date',
                  // value: /^\d{8}$/,
                },
              })}
            />
          </InputContainer>
          {/* <div className='button-next'>
            <Button
              type="button"
              children="Back"
              secondary
              style={{ margin: '0 10px' }}
              onClick={goBack}
            >Back <i class="fa fa-angle-left" aria-hidden="true"></i></Button>
            <Button children="Next" />
          </div> */}
          <div className='button-next'>
            <Button children="Next" >Press <span className="enter">Enter</span>  <i class="fa fa-angle-right" aria-hidden="true"></i></Button>
          </div>
          <p class="hidden-xs">&nbsp;</p>
          <div class="terms5">
            <p className='text-center'> Already have an account with us? <a href="/login">Please Sign In</a>
            </p>
          </div>
        </div>
      </form>
    </div>
  );
};
